export const breakPoints = {
    mobileBreakPoint: 768,
};

export default breakPoints;
